import { _getProdList, _download } from '../../../static/api/index'
import { preloadImage } from '../../../static/utils/index'
import moment from 'moment';
export default {
  name: "App",
  props: {
    parentMenuItem: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      moment,
      areaValue: [],
      current: localStorage.getItem("image-time") || 0,
      timeList: [],
      areaOptions: [],
      prodImgList: {},
      imgLen: 0,
      imgView: [],
      urlType: '',
      baseData: [],
      // areaParams: []
      timeListDefaultLen: 0,
      timerIndex: window.fyEarth.timeListDefaultLength,
      // 查看大图功能
      centerDialogVisible: false,
      // 大图数据
      bigImageData: {},
      // 控制是否开启鼠标移动
      isMousedown: false,
      // 开启滚轮缩放
      isHoverImg: false,
      // 移动的位置
      moveStart: {},
      // 缩放的坐标
      translate: {x: 0, y: 0},
      // 缩放的大小
      scale: 1,
      // 缩放的最大值和最小值
      scaleZoom: {
        max: 5,
        min: 0.2
      },
      PVT_proName: window.fyEarth.PVT_proName,
      // 动画
      loopImgUrl: '',
      isPlay: false,
      imgTime: {},
      sourceData: [],
      isOneProduct: false,
      timerInterval: null
    };
  },
  watch:{
    parentMenuItem: {
      handler(newValue){
        // 有区域时走区域选择逻辑，无区域时直接获取时次列表       
        if(Object.keys(newValue).length > 0 && newValue.region && newValue.region.length > 0){
          let area = this.parentMenuItem.region[0].enName

          this.changeOption([area])
        }
        if(Object.keys(newValue).length > 0 && newValue.region.length == 0) {
          this.getProdList()
        }
      },
      // immediate: true
    }
  },
  created() {
    console.log("parentMenuItem", this.parentMenuItem);
  },
  mounted(){
    this.upDownChangeTimeList()
    window.addEventListener('mousewheel', this.handleImgScroll, false)
    let mode = this.$router.history.current.query.mode
    if(mode == 'fullscreen'){
      document.getElementById("historyTitle").style.display = "block";
      document.getElementById("header").style.display = "none";
      document.getElementById("sliderBox").style.display = "none";
      document.getElementById("more").style.display = "none";
      document.getElementById("mainBox").style.height = "calc(100vh - 48px)";
      document.getElementById("mainBox").style.width = "calc(100% - 20px)"
      document.getElementById("main").style.height = "100vh";
    }
  },
  methods: {
    // 选择区域
    changeOption(value) {
      this.areaValue = value
      localStorage.setItem('area', value)
      if(value.length){
        this.areaOptions = this.region_array(this.parentMenuItem.region)
        this.getProdList()
      } else {
        this.timeList = []
      }
    },
    // 获取产品数据
    getProdList(){
      const prodName = localStorage.getItem('prodName')   
      let dataType = localStorage.getItem('dataType')
      let params = {}
      if(dataType !== 'undefined'){
        params = {
          abbr: prodName,
          region: this.$store.state.regionLength == 0 ? '' : this.areaValue,
          dataType: dataType
        }
      } else {
        params = {
          abbr: prodName,
          region: this.$store.state.regionLength == 0 ? '' : this.areaValue
        }
      }
      this.timeList = []
      // this.baseData = []
      this.prodImgList = {}
      let _data = []
      let mode = this.$router.history.current.query.mode
      clearInterval(this.timerInterval)
      this.timerInterval = null
      _getProdList(this.$store.state.logo, params).then((result)=>{
        _data = result.data
        this.setProd(_data, mode)
      })
    },
    setProd(_data, mode){
      if(_data.length){     
        // 判断当前产品下所有时次是否为单产品
        _data.forEach((_item)=>{
          this.isOneProduct = false
          if(_item.list.length == 1){
            this.isOneProduct = true
          }
          return this.isOneProduct
        })
        // this.baseData = _data
        // 需求：默认展示18条，点击more展示40条 注：接口返回40条信息
        this.timeListDefaultLen = _data.length > window.fyEarth.timeListDefaultLength ? window.fyEarth.timeListDefaultLength : _data.length

        // 专题图部分------
        if(mode == 'fullscreen'){
          this.timeList = _data
          this.sourceData = this.timeList
        } else {
          this.timeList = _data.slice(0, this.timeListDefaultLen)
          this.sourceData = this.timeList
        }
        // prodType 类型为 video时，左侧时次列表不显示
        // prodType 类型不为视频时，调用时次数据
        if (this.parentMenuItem.prodType == 'animation' && this.isOneProduct) {
          this.prodImgList = _data[0]
          this.loopImgUrl = _data[0].list[0].url
          this.imgTime = _data[0]
          // 当前进度值
          this.current = 0 
          this.$nextTick(() => {
            // 预加载图像
            preloadImage(this.sourceData)
          })
        } else if(this.parentMenuItem.prodType == 'video'){
          this.prodImgList = _data[0]
          let name = _data[0].list[0].url.split('.')
          this.urlType = name[name.length - 1]
        } else {     
          // 选择时次
          // this.loopImgUrl = ''
          // this.imgTime = {}   
          this.changeTime(this.timeList[0], 0)
        }
      }
    },
    // 改造区域数据结构
    region_array(dataParams) {
      var _this = this;
      var data = [];
      dataParams.forEach(function (v, i) {
        var city_one = { value: v.enName, label: v.enName};
        if (v.children.length) {
          city_one.children = _this.region_array(v.children);
        } 
        // else {
        //     city_one.children = [];
        // }
        data.push(city_one);
      });
      
      return data;
    },
    // 选择时次
    changeTime(prod, index) {
      localStorage.setItem("image-time", index);
      this.current = index;
      this.prodImgList = prod
      this.imgLen = prod.list.length
    },
    // 查看更多
    moreData() {
      window.open(window.location.href + '?mode=fullscreen')
    },
    // 下载zip/mp4/gif文件
    download(type){
      const prodName = localStorage.getItem('prodName')
      let params = {
        abbr: prodName,
        region: this.$store.state.regionLength == 0 ? '' : this.areaValue
      }
      _download(this.$store.state.logo, type, params).then((res)=>{
        console.log(type, 'res', res, )
        const blob = new Blob([res.data]); // 如类型为excel,type为：'application/vnd.ms-excel'
        const fileName = res.headers.filename || `${prodName}.${type}`;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // 点击后移除，防止生成很多个隐藏a标签
      })
    },
    // 监听键盘，控制上下键选择时次列表
    upDownChangeTimeList() { 
      console.log('timeListDefaultLen--', this.timeListDefaultLen)
      document.onkeydown = (e) => {
        //事件对象兼容
        let e1 = e || event || window.event || arguments.callee.caller.arguments[0]
        //键盘按键判断:左箭头-37;上箭头-38；右箭头-39;下箭头-40
        if (e1 && e1.keyCode == 38) {
          this.nextFrame()
        } else if (e1 && e1.keyCode == 40) {
          this.prevFrame()
        }
      }
    },
    // 上一帧
    prevFrame() {
      if (this.timerIndex >= this.timeList.length - 1) {
        this.timerIndex = 0
      } else {
        this.timerIndex++
      }
      this.prodImgList = this.timeList[this.timerIndex]
      // 当前进度值
      this.current = this.timerIndex
    },
    // 下一帧
    nextFrame() {
      if (this.timerIndex <= 0) {
        this.timerIndex = this.timeList.length - 1
      } else {
        this.timerIndex--
      }
      this.prodImgList = this.timeList[this.timerIndex]
      // 当前进度值
      this.current = this.timerIndex
    },
    // 查看大图功能
    // 动画暂停，点击图片查看大图
    bigImage(imgData){
      console.log()
      this.centerDialogVisible = true
      this.bigImageData = imgData
    },
    // // 关闭弹窗
    close(){
      this.centerDialogVisible = false
      this.isHoverImg = false
    },
    // 鼠标按下事件 拖动图片文件
    mousedownDragImg(e){
      e.preventDefault()
      
      // 获取元素
      var zoomBox = document.querySelector('.dragEle')
      var imgInfo = this.$refs.dragEle
      var x = e.pageX - imgInfo.offsetLeft
      var y = e.pageY - imgInfo.offsetTop
      imgInfo.style.margin = 'auto'

      // 添加鼠标移动事件
      zoomBox.addEventListener('mousemove', move)
    
      function move(e) {
        imgInfo.style.left = e.pageX - x + 'px'
        imgInfo.style.top = e.pageY - y + 'px'
      }
      // 添加鼠标抬起事件，鼠标抬起，将事件移除
      imgInfo.addEventListener('mouseup', function() {
        zoomBox.removeEventListener('mousemove', move)
      })
      // 鼠标离开元素，把事件移除
      zoomBox.addEventListener('mouseout', function() {
        zoomBox.removeEventListener('mousemove', move)
      })
      // 鼠标抬起事件 移除事件
      zoomBox.addEventListener('mouseup', function() {
        zoomBox.removeEventListener('mousemove', move)
      })
    },
    // 鼠标滚轮事件，开启缩放
    handleImgScroll(e) {
      if(this.isHoverImg) {
        let speed = e.wheelDelta / 120
        if(e.wheelDelta > 0 && this.scale < this.scaleZoom.max) {
          this.scale += 0.2 * speed
          this.$refs.dragEle.style.transform = `scale(${this.scale}) translate(${this.translate.x}px, ${this.translate.y}px)`
        }else if(e.wheelDelta < 0 && this.scale > this.scaleZoom.min){
          this.scale += 0.2 * speed
          this.$refs.dragEle.style.transform = `scale(${this.scale}) translate(${this.translate.x}px, ${this.translate.y}px)`
        }
      }
    },
    // 动画相关
    // 播放
    start() {
      this.loopImg()
      this.isPlay = false;
      this.timerInterval && clearInterval(this.timerInterval)
      this.timerInterval = null
      this.timerInterval = setInterval(() => {
        this.loopImg()
      }, window.fyEarth.animationSpeed)
    },

    // 图片loop
    loopImg() {
      this.timerIndex--
      // localStorage.setItem('timerIndex', this.timerIndex)
      if (this.timerIndex >= 0) {
        this.loopImgUrl = this.timeList[this.timerIndex].list[0].url
        this.imgTime = this.timeList[this.timerIndex]
        // 当前进度值
        this.current = this.timerIndex
      } else {
        this.timerIndex = this.timeListDefaultLen
      }
    },
    // 播放
    play() {
      this.isPlay = false;
      this.start()
    },
    // 暂停
    paused() {
      this.isPlay = true
      this.timerInterval && clearInterval(this.timerInterval)
      this.timerInterval = null
    },
  },
};